
import classes from './RadioInput.module.scss';

const RadioInput = ({ validation, input, type = 'simple', register = () => { }, ...props }) => {    
    return (
        <>
            {type === 'survey' ? (
                <div
                    onClick={() => document.getElementById(input.id)?.click()}
                    className={`${classes['survey']} position-relative`}
                >
                    <input
                        type="radio"
                        className={classes['radio-input']}
                        {...input}
                        {...register(input.name, validation)}
                        {...props}
                    />
                    <label className={classes['radio-label']} htmlFor={input.id}>{input.label}</label>
                </div>
            ) : (
                <div className='position-relative'>
                    <input
                        type="radio"
                        className={classes['radio-input']}
                        {...input}
                        {...register(input.name, validation)}
                        {...props}
                    />
                    <label className={classes['radio-label']} htmlFor={input.id}>{input.label}</label>
                </div>
            )}
        </>

    );
};

export default RadioInput;